import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import home9 from './Component//home/home9.png';
import home3 from './Component/home//home2.jpg';
import home5 from './Component/home//home6.jpg';
import home6 from './Component/home//home7.jpg';
import brand1 from './Component/home/brand1.png';
import brand2 from './Component/home/brand2.png';
import i1 from './Component/i1.png';
import carpet from './Component/product/h1.png';
import hardwood from './Component/product/h2.png';
import laminate from './Component/product/h3.png';
import Tile from './Component/product/h4.png';
import new1 from './Component/new1.jpg';
import new2 from './Component/new2.jpg';
import homenewCheif from './Component/homenewCheif.png';
import logo from './Component/home/logo512.png';
import chiefLogo from './Component/home/CCMLOGO.png';
import showroomKitchen from './Component/home/4869.jpg';
import showroomIsland from './Component/home/4867.jpg';
import showroomHardware from './Component/home/4866.jpg';
import showroomSink from './Component/home/4861.jpg';
import showroomCoffee from './Component/home/4863.jpg';
import showroomVanity from './Component/home/4864.jpg';
import showroomTub from './Component/home/4865.jpg';
import showroomKitchenFull from './Component/home/4862.jpg';

const products = [
	{ img: carpet, title: 'Carpet', href: '/products/carpet', alt: 'Carpet flooring options' },
	{ img: hardwood, title: 'Hardwood', href: '/products/hardwood', alt: 'Hardwood flooring options' },
	{ img: laminate, title: 'Luxury Vinyl', href: '/products/luxuryvinyl', alt: 'Luxury vinyl flooring options' },
	{ img: Tile, title: 'Tile', href: '/products/Tile', alt: 'Tile flooring options' },
];

const serviceCards = [
	{
		icon: 'bi-star-fill',
		title: 'Reviews',
		text: 'The Cassville, MO area trusts Nickles Flooring for all of their flooring needs.',
		href: '/reviews',
		cta: 'Our Reviews',
	},
	{
		icon: 'bi-calendar-check',
		title: 'Request',
		text: 'Request your accurate and professional in-home flooring estimate.',
		href: '/free-estimate',
		cta: 'Schedule Now',
	},
	{
		icon: 'bi-house-gear',
		title: 'Services',
		text: 'Our professional flooring installers are ready to help you with your next project.',
		href: '/flooring-services',
		cta: 'What We Offer',
	},
	{
		icon: 'bi-credit-card',
		title: 'Financing',
		text: 'Get your dream floors now, pay over time with our convenient financing options, subject to approved credit.',
		href: '/financing',
		cta: 'Learn More',
	},
];

const whyChooseUs = [
	'In-House Design Consultants',
	'Commitment to Excellence',
	'Family Owned & Operated',
	'Knowledgeable Staff',
	'Buying Power',
	'Large Selection In-stock',
];

const kitchenBathProducts = [
	'Cabinets',
	'Cabinet Hardware',
	'Vanities',
	'Sinks & Faucets',
	'Tubs & Toilets',
	'Custom Showers',
	'All Types of Floors',
];

function Home() {
	const currentDate = new Date();
	const endDate = new Date('2025-06-20');
	const showAnniversaryInfo = currentDate <= endDate;

	return (
		<div className="bg-gray-50">
			<Headers />

			{/* Carousel */}
			<section className="bg-white">
				<div id="carouselExampleInterval" className="carousel slide" data-bs-ride="carousel">
					<div className="carousel-inner">
						<div className="carousel-item active" data-bs-interval="3000">
							<a href="/free-estimate" className="block">
								<img
									src={home3}
									alt="Flooring, furniture and hardware needs"
									className="mx-auto w-full h-auto"
								/>
							</a>
						</div>
						<div className="carousel-item" data-bs-interval="3000">
							<a href="tel:+14173427662" className="block">
								<img
									src={homenewCheif}
									alt="Chief Construction Management"
									className="mx-auto w-full h-auto"
								/>
							</a>
						</div>
						<div className="carousel-item" data-bs-interval="3000">
							<div className="flex flex-col">
								<a href="tel:+14173120044" className="block flex-1">
									<img
										src={new1}
										alt="Contact Nickle's Flooring"
										className="mx-auto w-full h-auto"
									/>
								</a>
								<a href="tel:+14173427662" className="block flex-1">
									<img
										src={new2}
										alt="Contact Chief Construction"
										className="mx-auto w-full h-auto"
									/>
								</a>
							</div>
						</div>
					</div>
					<button
						className="carousel-control-prev"
						type="button"
						data-bs-target="#carouselExampleInterval"
						data-bs-slide="prev"
					>
						<span className="carousel-control-prev-icon" aria-hidden="true" />
						<span className="visually-hidden">Previous</span>
					</button>
					<button
						className="carousel-control-next"
						type="button"
						data-bs-target="#carouselExampleInterval"
						data-bs-slide="next"
					>
						<span className="carousel-control-next-icon" aria-hidden="true" />
						<span className="visually-hidden">Next</span>
					</button>
				</div>
			</section>

			{/* Anniversary — date-gated */}
			{showAnniversaryInfo && (
				<section className="py-10 md:py-14" style={{ background: 'linear-gradient(to right, #803333, #9a4444, #803333)' }}>
					<div className="container mx-auto px-4">
						<div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden border-t-4 border-[#803333]">
							<div className="p-6 md:p-10 text-center">
								<span className="inline-flex items-center gap-2 bg-[#803333] text-white text-sm font-semibold px-4 py-2 rounded-full mb-4">
									<i className="bi bi-calendar-event" />
									35 Years of Excellence
								</span>
								<h2 className="text-2xl md:text-4xl font-bold text-[#803333] mb-2">
									Anniversary Celebration!
								</h2>
								<p className="text-lg font-medium text-gray-800 mb-2">
									Friday June 13 & Saturday June 14, 2025
								</p>
								<p className="text-gray-600 mb-8">
									Join us for special sales, meet our vendors, and celebrate 35 years of service!
								</p>

								<div className="grid md:grid-cols-2 gap-4 text-start mb-8">
									<div className="p-5 rounded-xl border-2 border-[#803333]/20">
										<h3 className="text-lg font-bold text-[#803333] mb-3 flex items-center gap-2">
											<i className="bi bi-tags" /> Sale Event
										</h3>
										<ul className="space-y-2 text-sm text-gray-700 list-none p-0 m-0">
											<li className="flex gap-2"><i className="bi bi-check-circle-fill text-[#803333] mt-0.5" />Sale pricing on luxury vinyl plank</li>
											<li className="flex gap-2"><i className="bi bi-check-circle-fill text-[#803333] mt-0.5" />Exclusive deals on carpet and area rugs</li>
											<li className="flex gap-2"><i className="bi bi-check-circle-fill text-[#803333] mt-0.5" />Flooring sales reps on-site with special offers</li>
											<li className="flex gap-2"><i className="bi bi-check-circle-fill text-[#803333] mt-0.5" />Grand Opening of Chief Construction Management</li>
										</ul>
									</div>
									<div className="p-5 rounded-xl border-2 border-[#803333]/20">
										<h3 className="text-lg font-bold text-[#803333] mb-3 flex items-center gap-2">
											<i className="bi bi-tools" /> New Services
										</h3>
										<ul className="space-y-2 text-sm text-gray-700 list-none p-0 m-0">
											<li className="flex gap-2"><i className="bi bi-check-circle-fill text-[#803333] mt-0.5" />Full bathroom remodeling, tubs, faucets & custom showers</li>
											<li className="flex gap-2"><i className="bi bi-check-circle-fill text-[#803333] mt-0.5" />Kitchen cabinets, granite & quartz countertops</li>
											<li className="flex gap-2"><i className="bi bi-check-circle-fill text-[#803333] mt-0.5" />Concrete, asphalt, and home fencing</li>
											<li className="flex gap-2"><i className="bi bi-check-circle-fill text-[#803333] mt-0.5" />Construction services of all types</li>
										</ul>
									</div>
								</div>

								<div className="flex flex-wrap items-center justify-center gap-6 mb-8">
									<img src={logo} alt="Nickle's Flooring" className="max-w-[160px] h-auto" />
									<img src={chiefLogo} alt="Chief Construction Management" className="max-w-[160px] h-auto" />
								</div>

								<div className="flex flex-wrap justify-center gap-3">
									<a
										href="/about-us"
										className="inline-flex items-center gap-2 bg-[#803333] text-white font-semibold px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
									>
										Learn More <i className="bi bi-arrow-right" />
									</a>
									<a
										href="/free-estimate"
										className="inline-flex items-center gap-2 border-2 border-[#803333] text-[#803333] font-semibold px-5 py-2.5 rounded-lg no-underline hover:bg-[#803333]/5 transition-colors"
									>
										Get a Free Estimate
									</a>
								</div>
							</div>
						</div>
					</div>
				</section>
			)}

			{/* Product catalog */}
			<section className="py-12 md:py-16">
				<div className="container mx-auto px-4 text-center">
					<h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
						Looking for new floors in the Cassville, MO area?
					</h2>
					<p className="text-sm uppercase tracking-wide text-gray-500 mb-8">
						Shop our extensive flooring catalog
					</p>
					<div className="row g-4 justify-content-center">
						{products.map((product) => (
							<div key={product.href} className="col-md-3 col-6">
								<a
									href={product.href}
									className="group block h-100 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden no-underline transition-all hover:-translate-y-1 hover:shadow-md"
								>
									<img
										src={product.img}
										alt={product.alt}
										className="w-full aspect-[4/3] object-cover"
									/>
									<div className="p-3 text-center">
										<h3 className="text-base font-semibold text-gray-900 m-0 group-hover:text-[#803333] transition-colors">
											{product.title}
										</h3>
									</div>
									<div
										className="py-2.5 text-center text-sm font-medium text-white"
										style={{ backgroundColor: '#803333' }}
									>
										Browse Options
									</div>
								</a>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* Free estimate banner */}
			<section className="pb-4">
				<a href="/free-estimate" className="block overflow-hidden hover:opacity-95 transition-opacity">
					<img
						src={home9}
						alt="Request a free estimate"
						className="mx-auto w-full h-auto"
					/>
				</a>
			</section>

			{/* New Kitchen & Bath Showroom */}
			<section className="py-12 md:py-16 bg-white border-y border-gray-100">
				<div className="container mx-auto px-4">
					<div className="text-center mb-8 md:mb-10">
						<span className="inline-flex items-center gap-2 bg-[#803333]/10 text-[#803333] text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full mb-3">
							Now Open
						</span>
						<h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
							New Kitchen & Bath Showroom
						</h2>
						<p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto m-0">
							We now sell cabinets and hardware, vanities, sinks, faucets, tubs, toilets, custom showers — and of course all types of floors.
						</p>
					</div>

					<div className="row g-3 g-md-4 mb-8">
						{[
							{ src: showroomKitchenFull, title: 'Full Kitchen Suite', caption: 'Cabinets, counters & appliances', alt: 'Complete modern kitchen display' },
							{ src: showroomSink, title: 'Sinks & Faucets', caption: 'Farmhouse sinks & modern faucets', alt: 'Farmhouse sink and matte black faucet' },
							{ src: showroomCoffee, title: 'Custom Cabinetry', caption: 'Layouts with sleek hardware', alt: 'Kitchen coffee station cabinetry' },
							{ src: showroomVanity, title: 'Vanities & Hardware', caption: 'Bath vanities & Jeffrey Alexander', alt: 'Showroom vanity and hardware display' },
							{ src: showroomTub, title: 'Freestanding Tubs', caption: 'Soaking tubs & floor fillers', alt: 'Freestanding bathtub display' },
							{ src: showroomHardware, title: 'Cabinet Hardware', caption: 'Knobs & pulls for every style', alt: 'Jeffrey Alexander cabinet hardware' },
							{ src: showroomKitchen, title: 'Kitchen Displays', caption: 'Cabinets, counters, sinks & faucets', alt: 'Kitchen cabinets and counters' },
							{ src: showroomIsland, title: 'Islands & Cabinetry', caption: 'Modern finishes and layouts', alt: 'Kitchen island showroom' },
						].map((item) => (
							<div key={item.title} className="col-6 col-md-3">
								<a href="/kitchen-bath-showroom" className="group block overflow-hidden rounded-2xl shadow-sm border border-gray-100 no-underline h-100">
									<img
										src={item.src}
										alt={item.alt}
										className="w-full aspect-[4/5] object-cover transition-transform duration-300 group-hover:scale-105"
									/>
									<div className="p-3 bg-white">
										<h3 className="text-sm font-bold text-gray-900 m-0 group-hover:text-[#803333] transition-colors">
											{item.title}
										</h3>
										<p className="text-xs text-gray-500 m-0 mt-1">{item.caption}</p>
									</div>
								</a>
							</div>
						))}
					</div>

					<div className="flex flex-wrap justify-center gap-2 mb-8">
						{kitchenBathProducts.map((item) => (
							<span
								key={item}
								className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-3 py-1.5 text-xs font-semibold text-gray-700"
							>
								{item}
							</span>
						))}
					</div>

					<div className="text-center">
						<a
							href="/kitchen-bath-showroom"
							className="inline-flex items-center gap-2 bg-[#803333] text-white font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
						>
							Explore the Showroom
							<i className="bi bi-arrow-right" />
						</a>
					</div>
				</div>
			</section>

			{/* Service cards */}
			<section className="py-12 md:py-16 bg-[#803333]">
				<div className="container mx-auto px-4">
					<div className="row g-4">
						{serviceCards.map((card) => (
							<div key={card.title} className="col-md-3 col-sm-6">
								<div className="h-100 bg-white rounded-xl shadow-sm p-5 flex flex-col transition-all hover:-translate-y-1 hover:shadow-md">
									<div className="text-center mb-3">
										<span className="inline-flex w-12 h-12 items-center justify-center rounded-xl bg-[#803333]/10 text-[#803333]">
											<i className={`bi ${card.icon} text-xl`} />
										</span>
									</div>
									<h3 className="text-lg font-bold text-center text-gray-900 mb-2">
										{card.title}
									</h3>
									<p className="text-sm text-gray-600 text-center flex-grow mb-4">
										{card.text}
									</p>
									<a
										href={card.href}
										className="mt-auto block text-center text-white text-sm font-semibold py-2.5 rounded-lg no-underline hover:opacity-90 transition-opacity"
										style={{ backgroundColor: '#803333' }}
									>
										{card.cta}
									</a>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* About */}
			<section className="py-12 md:py-16">
				<div className="container mx-auto px-4">
					<div className="row align-items-center g-4">
						<div className="col-lg-6">
							<div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8">
								<h2 className="text-2xl md:text-3xl font-bold text-[#803333] mb-4">
									Serving you and your home for 35 years!
								</h2>
								<p className="text-gray-600 mb-3 leading-relaxed">
									Being a family-owned and operated business, we&apos;re able to offer you that personal touch you&apos;ve been looking for. Our goal is to always make all of our customers happy, and we believe in treating each customer like a part of our family.
								</p>
								<p className="text-gray-600 mb-3 leading-relaxed">
									We look forward to hearing from you soon! And when you&apos;re in Cassville we hope you come in and visit.
								</p>
								<p className="text-gray-600 mb-5 leading-relaxed">
									Builders & Contractors: We have a special program in place for your new home construction and full home remodels. Call us today for details.
								</p>
								<a
									href="/about-us"
									className="inline-flex items-center gap-2 bg-[#803333] text-white font-semibold px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
								>
									About Us <i className="bi bi-arrow-right" />
								</a>
							</div>
						</div>
						<div className="col-lg-6">
							<img
								src={home5}
								alt="Nickle's Flooring store"
								className="w-full h-auto rounded-xl shadow-sm object-cover"
							/>
						</div>
					</div>
				</div>
			</section>

			{/* Why choose us */}
			<section className="py-12 md:py-16 bg-white">
				<div className="container mx-auto px-4">
					<div className="row align-items-center g-4">
						<div className="col-lg-6 order-lg-2">
							<div className="bg-gray-50 rounded-xl border border-gray-100 p-6 md:p-8">
								<h2 className="text-2xl md:text-3xl font-bold text-[#803333] mb-6">
									Why choose us?
								</h2>
								<div className="row g-3 mb-6">
									{whyChooseUs.map((item) => (
										<div key={item} className="col-sm-6">
											<div className="flex items-center gap-2 text-gray-800">
												<i className="bi bi-check-circle-fill text-[#803333]" />
												<span className="text-sm font-medium">{item}</span>
											</div>
										</div>
									))}
								</div>
								<a
									href="/free-estimate"
									className="inline-flex items-center gap-2 bg-[#803333] text-white font-semibold px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
								>
									Request an Estimate <i className="bi bi-arrow-right" />
								</a>
							</div>
						</div>
						<div className="col-lg-6 order-lg-1">
							<img
								src={home6}
								alt="Nickle's Flooring team"
								className="w-full h-auto rounded-xl shadow-sm object-cover"
							/>
						</div>
					</div>
				</div>
			</section>

			{/* Get inspired */}
			<section className="py-12 md:py-16">
				<div className="container mx-auto px-4">
					<div className="row g-4 align-items-stretch">
						<div className="col-lg-4">
							<div className="h-100 p-6 md:p-8 bg-[#803333] text-white rounded-xl shadow-sm flex flex-col">
								<h2 className="text-2xl md:text-3xl font-bold mb-4 text-center">
									Get inspired
								</h2>
								<p className="text-white/90 text-center text-sm leading-relaxed mb-6 flex-grow">
									We&apos;ve got you covered from: flooring, carpet, hardwood, waterproof hardwood, plank, tile, flooring supplies, flooring tools, custom showers, backsplashes, sinks, faucets, & vanity tops.
								</p>
								<div className="text-center mt-auto">
									<a
										href="/inspiration"
										className="inline-flex items-center gap-2 bg-white text-[#803333] font-semibold px-5 py-2.5 rounded-lg no-underline hover:bg-white/90 transition-colors"
									>
										View our Galleries <i className="bi bi-images" />
									</a>
								</div>
							</div>
						</div>
						<div className="col-lg-8">
							<img
								src={i1}
								alt="Inspiration gallery"
								className="w-full h-100 min-h-[240px] object-cover rounded-xl shadow-sm"
							/>
						</div>
					</div>
				</div>
			</section>

			{/* Request estimate form */}
			<section className="py-4 bg-white border-y border-gray-100">
				<Request />
			</section>

			{/* Brands */}
			<section className="py-12 md:py-16">
				<div className="container mx-auto px-4">
					<h2 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-8">
						Featured brands & technologies
					</h2>
					<div className="space-y-6">
						<img
							src={brand1}
							alt="Featured flooring brands"
							className="mx-auto d-block max-w-full h-auto"
						/>
						<img
							src={brand2}
							alt="Featured flooring technologies"
							className="mx-auto d-block max-w-full h-auto"
						/>
					</div>
				</div>
			</section>

			<Footer />
		</div>
	);
}

export default Home;
